import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverTeamMiniEntity } from '../../domain/entities/DriverTeamMiniEntity'
import type { DriverTeamListedAdminDto } from '@/backend/market'

export class DriverTeamMiniModel extends DriverTeamMiniEntity {
  constructor(dataDto: DriverTeamListedAdminDto) {
    super()
    mapEntityProperties<DriverTeamMiniEntity>(this, dataDto)
  }
}
